export const pureApiFetch = (url, params, okCallback, errCallback) => {
    fetch(url, params)
        .then((res) => {
            if (res.ok) {
                if (okCallback) {
                    try {
                        res.json().then(json => {
                            okCallback(json);
                        });
                    } catch (e) {
                        okCallback(res);
                    }
                }
            } else {
                res.json().then(json => {
                    errCallback(res.status + ":" + res.statusText, json);
                });

            }
        })
        .catch((error) => {
            if (errCallback) {
                errCallback(error | error.message);
            }
        });
};
